<template>
	<v-container v-if="profileData">
		<v-row justify="center">
			<v-col
				cols="12"
				sm="10"
				md="7"
				:class="{
					routerViewDark: $vuetify.theme.isDark,
					routerViewLight: !$vuetify.theme.isDark,
				}"
			>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<label for="upload" class="pointer" v-on="on">
							<avatar
								size="120"
								:name="profileData.name"
								:last-name="profileData.lastName"
								:url="profileData.img"
								:loading="loadingUpload"
							/>
						</label>
						<v-file-input
							id="upload"
							ref="avatar"
							v-model="avatar"
							class="d-none"
							dense
							filled
							hide-details
							accept="image/jpeg, image/png, image/gif, image/jpg"
							placeholder="Agrega una imagen"
							drop-placeholder="Arrastrar aqui..."
							@change="onFileUpload"
						></v-file-input>
					</template>
					<span>Sube o cambia la imagen</span>
				</v-tooltip>
			</v-col>
			<v-col v-if="profileData.name" cols="10" sm="10" md="7" class="subtitle-1 pb-0">
				{{ `${profileData.name} ${profileData.lastName && profileData.lastName}` }}
			</v-col>
			<v-col
				v-if="profileData.role"
				cols="10"
				sm="10"
				md="7"
				class="primary--text title py-0"
			>
				{{ profileData.role == 'admin' ? 'Administrador' : 'Super usuario' }}
			</v-col>
			<v-col v-if="profileData.analyst" cols="12" md="7" class="overline py-0">
				Analista
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="12" sm="10" md="7">
				<v-form>
					<v-row>
						<v-col cols="12" class="text-left text--secondary caption">
							Datos personales
						</v-col>
						<v-col cols="12" class="my-0 py-0"
							><v-text-field
								solo
								v-model.trim="profileData.email"
								dense
								outlined
								disabled
								filled
								persistent-hint
								hint="Email"
							></v-text-field>
						</v-col>
						<v-col cols="12" class="my-0 py-0"
							><v-text-field
								solo
								id="firstname"
								v-model.trim="profileData.name"
								dense
								outlined
								filled
								persistent-hint
								hint="Nombre"
								:error-messages="nameErrors"
								@input="$v.profileData.name.$touch()"
								@blur="$v.profileData.name.$touch()"
							></v-text-field>
						</v-col>
						<v-col cols="12" class="my-0 py-0">
							<v-text-field
								solo
								id="lastname"
								v-model.trim="profileData.lastName"
								dense
								outlined
								filled
								persistent-hint
								hint="Apellido"
								:error-messages="lastnameErrors"
								@input="$v.profileData.lastName.$touch()"
								@blur="$v.profileData.lastName.$touch()"
							></v-text-field>
						</v-col>
						<v-col cols="12" class="my-0 py-0">
							<v-text-field
								solo
								id="company"
								v-model="profileData.company"
								dense
								outlined
								filled
								persistent-hint
								hint="Empresa"
								:error-messages="companyErrors"
								@input="$v.profileData.company.$touch()"
								@blur="$v.profileData.company.$touch()"
							></v-text-field>
						</v-col>

						<v-col cols="12" class="my-0 py-0">
							<v-text-field
								solo
								id="userPhone"
								v-model="profileData.phone"
								dense
								outlined
								filled
								persistent-hint
								hint="Teléfono"
								placeholder="Ingresar tú numero, te ayudará a recibir notificaciones"
								:error-messages="phoneErrors"
								@input="$v.profileData.phone.$touch()"
								@blur="$v.profileData.phone.$touch()"
							></v-text-field>
						</v-col>
						<v-col cols="12" class="my-0 py-0">
							<v-text-field
								solo
								v-model="profileData.downloadTime"
								dense
								outlined
								filled
								persistent-hint
								hint="Tiempo de descarga. Ej: 50  -> Descargará desde hace 50 dias o ej: 10-2021   -> Descargará solo Octubre 2021"
							></v-text-field>
						</v-col>
						<v-col cols="12" class="my-0 py-0">
							<v-menu
								ref="menu"
								v-model="menu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="profileData.adminNotifyTime"
								transition="scale-transition"
								offset-y
								max-width="290px"
								min-width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										solo
										v-model="profileData.adminNotifyTime"
										persistent-hint
										hint="Hora de notificación"
										label="Hora de notificación para mañana en documentos por caducar y comienzo de actividades"
										readonly
										outlined
										dense
										filled
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-time-picker
									v-if="menu"
									v-model="profileData.adminNotifyTime"
									format="24hr"
									full-width
									@click:minute="$refs.menu.save(profileData.adminNotifyTime)"
								></v-time-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-form>
			</v-col>
		</v-row>

		<v-row justify="center">
			<v-col cols="12" sm="10" md="7">
				<v-btn text block small :loading="loading" color="primary" @click="submitForm">
					Actualizar
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="12" sm="10" md="7"><v-divider /></v-col>
		</v-row>
		<UserSharing :user-emails="userSharingEmails" />
		<v-row justify="center">
			<v-col cols="12" sm="10" md="7"><v-divider /></v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="12" sm="10" md="7" class="text-left text--secondary caption">
				Seguridad
			</v-col>
			<v-col cols="12" sm="10" md="7">
				<v-text-field
					id="new-password"
					v-model.trim="securityData.newPassword"
					type="password"
					dense
					outlined
					filled
					hide-details
					label="Nueva contraseña"
					:error-messages="newPasswordErrors"
					@input="$v.securityData.newPassword.$touch()"
					@blur="$v.securityData.newPassword.$touch()"
					solo
				>
				</v-text-field>
			</v-col>
			<v-col cols="12" sm="10" md="7">
				<v-btn
					block
					text
					small
					:loading="loadingUpdatePassword"
					color="primary"
					@click="submitNewPassword"
					>Actualizar contraseña
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, maxLength, required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
	name: 'UserTypeAdmin',
	components: {
		Avatar: () => import('@/components/ui/Avatar'),
		UserSharing: () => import('@/components/user/UserSharing'),
	},
	mixins: [validationMixin],
	data() {
		return {
			menu: false,
			avatar: null,
			loadingUpload: false,
			loadingUpdatePassword: false,
			profileData: {
				name: '',
				lastName: '',
				company: '',
				phone: '',
				analyst: false,
				img: '',
				adminNotifyTime: '',
				downloadTime: '',
			},
			securityData: {
				newPassword: '',
			},
			securityErrors: false,
		};
	},
	computed: {
		nameErrors() {
			const errors = [];
			if (!this.$v.profileData.name.$dirty) return errors;
			!this.$v.profileData.name.minLength && errors.push('Minimo 5 Caracteres');
			!this.$v.profileData.name.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		lastnameErrors() {
			const errors = [];
			if (!this.$v.profileData.lastName.$dirty) return errors;
			!this.$v.profileData.lastName.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.profileData.lastName.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		companyErrors() {
			const errors = [];
			if (!this.$v.profileData.company.$dirty) return errors;
			!this.$v.profileData.company.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.profileData.company.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		phoneErrors() {
			const errors = [];
			if (!this.$v.profileData.phone.$dirty) return errors;
			!this.$v.profileData.phone.minLength && errors.push('Minimo 8 Caracteres');
			return errors;
		},
		newPasswordErrors() {
			const errors = [];
			if (!this.$v.securityData.newPassword.$dirty) return errors;
			!this.$v.securityData.newPassword.minLength && errors.push('Minimo 5 Caracteres');
			!this.$v.securityData.newPassword.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		...mapGetters({
			userSharingEmails: 'User/userSharingEmails',
			message: 'User/message',
			loading: 'User/loading',
			profile: 'User/profile',
		}),
	},
	watch: {
		message(newVal) {
			this.toast(newVal.type, newVal.text);
		},
	},
	async mounted() {
		this.profileData = { ...this.profile };
	},
	methods: {
		async submitNewPassword() {
			this.$v.securityData.$touch();
			if (!this.$v.securityData.$invalid) {
				this.loadingUpdatePassword = true;
				this.securityErrors = false;
				await this.updatePassword(this.securityData.newPassword);
				this.profileData = { ...this.profile };
				this.loadingUpdatePassword = false;
			}
		},
		onFileUpload() {
			this.loadingUpload = true;
			const avatar = this.setAvatarObject(this.avatar);
			this.updateAvatar(avatar).then(this.clearUpload);
		},
		setAvatarObject(file) {
			const avatar = new FormData();
			avatar.append('avatar', file);
			return avatar;
		},
		clearUpload() {
			this.avatar = null;
			this.loadingUpload = false;
			this.profileData = this.getProfile;
		},
		async submitForm() {
			this.$v.profileData.$touch();
			if (!this.$v.profileData.$invalid) {
				await this.updateProfile(this.profileData);
				this.clearUpload();
				this.$router.replace({ name: 'activities' });
			}
		},
		toast(type, text) {
			this.snackbar({
				content: text,
				color: type,
			});
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
		...mapActions({
			updateProfile: 'User/updateProfile',
			updateAvatar: 'User/updateAvatar',
			updatePassword: 'User/updatePassword',
			fetchProfile: 'User/fetchProfile',
		}),
	},
	validations: {
		profileData: {
			name: {
				minLength: minLength(5),
				maxLength: maxLength(100),
			},
			lastName: {
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			phone: {
				minLength: minLength(8),
			},
			company: {
				minLength: minLength(3),
				maxLength: maxLength(100),
				required,
			},
		},
		securityData: {
			newPassword: {
				minLength: minLength(5),
				maxLength: maxLength(100),
				required,
			},
		},
	},
};
</script>

<style media="screen">
.routerViewLight {
	background-color: #ffffffad;
	border-radius: 0px 0px 25px 25px;
	padding-bottom: 20px;
	margin-bottom: 20px;
}
.routerViewDark {
	background-color: #000000ad;
	border-radius: 0px 0px 25px 25px;
	padding-bottom: 20px;
	margin-bottom: 20px;
}
</style>
